import { Button, Stack } from '@mui/material'
import { ConfluencePage } from '../types'
import PageHeader, { PageHeaderProps } from './PageHeader'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { ArrowBack } from '@mui/icons-material'
import ConfluencePageLinkButton from './ConfluencePageLinkButton'

export interface ConcluencePageHeaderProps extends Omit<
  PageHeaderProps,
  'backButton' | 'hideBackButton'
> {
  page?: ConfluencePage
}

export default function ConfluencePageHeader({
  page,
  ...props
}: ConcluencePageHeaderProps): React.ReactElement {
  /**
   * The translate function.
   */
  const { t } = useTranslation('common')

  /**
   * The navigate function.
   */
  const navigate = useNavigate()

  return (
    <PageHeader
      {...props}
      backButton={
        <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
          <Button variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
            {t('back')}
          </Button>

          {page && <ConfluencePageLinkButton page={page} />}
        </Stack>
      }
    />
  )
}
